/**
 * Created by minimus on 26.02.2015.
 */
let sam = /*sam ||*/ {};
(function($) {
  let media;
  const mediaTexts = options.media;
  const itemID = parseInt(options.item, 10);
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;

  sam.media = media = {};
  sam.media = media = {
    buttonId: '#banner-media',
    adUrl: '#img',
    adImgId: '#img_id',
    adName: '#title',
    adDesc: '#description',
    adAlt: '#alt',

    init: function () {
      $(this.buttonId).on('click', this.openMediaDialog);
    },

    openMediaDialog: function (e) {
      e.preventDefault();

      if (this._frame) {
        this._frame.open();
        return;
      }

      this._frame = media.frame = wp.media({
        title: mediaTexts.title,
        button: {
          text: mediaTexts.button
        },
        multiple: false,
        library: {
          type: 'image'
        }
      });

      this._frame.state('library').on('select', () => {
        const attachment = this.get('selection').single();
        media.handleMediaAttachment(attachment);
      });

      this._frame.open();
    },

    handleMediaAttachment: function (a) {
      const attachment = a.toJSON();
      $(this.adUrl).val(attachment.url);
      $(this.adImgId).val(attachment.id);
      if ('' === $(this.adName).val() && '' !== attachment.title) $(this.adName).val(attachment.title);
      if ('' === $(this.adDesc).val() && '' !== attachment.caption) $(this.adDesc).val(attachment.caption);
      if ('' === $(this.adAlt).val() && '' !== attachment.alt) $(this.adAlt).val(attachment.alt);
    }
  };
  $(document).ready(function() {
    $('#tabs').ejTab({enablePersistence: true});
    media.init();

    const rcami = $('#rc-ami');
    const rcamc = $('#rc-amc');
    const rcamd = $('#rc-amd');

    $("input:radio[name=amode]").on('click', () => {
      const cval = parseInt($('input:radio[name=amode]:checked').val(), 10);
      if(cval === 0) {
        if(rcami.is(':hidden')) rcami.show('blind', {direction:'vertical'}, 500);
        if(rcamc.is(':visible')) rcamc.hide('blind', {direction:'vertical'}, 500);
        if(rcamd.is(':visible')) rcamd.hide('blind', {direction:'vertical'}, 500);
      }
      else if(cval === 1) {
        if(rcamc.is(':hidden')) rcamc.show('blind', {direction:'vertical'}, 500);
        if(rcami.is(':visible')) rcami.hide('blind', {direction:'vertical'}, 500);
        if(rcamd.is(':visible')) rcamd.hide('blind', {direction:'vertical'}, 500);
      }
      else if(cval === 2) {
        if(rcamd.is(':hidden')) rcamd.show('blind', {direction:'vertical'}, 500);
        if(rcamc.is(':visible')) rcamc.hide('blind', {direction:'vertical'}, 500);
        if(rcami.is(':visible')) rcami.hide('blind', {direction:'vertical'}, 500);
      }
    });

    const rcSale = $('#rc-sale');
    const sale = $('#sale');
    const rcSaleMode = $('#rc-sale-mode');

    sale.on('click', () => {
      if(sale.is(':checked')) rcSale.show('blind', {direction:'vertical'}, 500);
      else rcSale.hide('blind', {direction:'vertical'}, 500);
    });

    $("input:radio[name=sale_mode]").on('click', () => {
      const cval = parseInt($('input:radio[name=sale_mode]:checked').val(), 10);
      if(cval === 0) {
        if(rcSaleMode.is(':hidden')) rcSaleMode.show('blind', {direction:'vertical'}, 500);
      }
      else {
        if(rcSaleMode.is(':visible')) rcSaleMode.hide('blind', {direction:'vertical'}, 500);
      }
    });

    const cBefore = $('#code_before');
    const cAfter = $('#code_after');
    const adWidth = $('#width').val() + 'px';
    const adHeight = $('#height').val() + 'px';
    const cntStyle = $('#cnt_style');

    $('.cnt-helper').on('click', (e) => {
      const target = e.currentTarget;
      switch (target.id) {
        case 'cnt-center':
          cntStyle.text("display: flex; justify-content: center; align-items: center;");
          break;
        case 'cnt-left':
          cntStyle.text("display: flex; justify-content: start; align-items: start;");
          break;
        case 'cnt-right':
          cntStyle.text("display: flex; justify-content: end; align-items: end;");
          break;
        case 'cnt-float-left':
          cntStyle.text(`float: left; width: ${adWidth}; display: flex; justify-content: center; align-items: center;`);
          break;
        case 'cnt-float-right':
          cntStyle.text(`float: right; width: ${adWidth}; display: flex; justify-content: center; align-items: center;`);
          break;
        case 'cnt-sizes':
          cntStyle.text(`${cntStyle.text()} width: ${adWidth}; height: ${adHeight};`);
          break;
        default: break;
      }
    });

    // Tooltips
    $('label[for="cnt_direction_0"]').qtip({
      content: {
        text: options.tooltip.row.content,
        title: options.tooltip.row.title
      },
      style: {
        classes: 'qtip-dark',
        width: '275px'
      },
      position: {
        my: 'left center'
      }
    });

    $('label[for="cnt_direction_1"]').qtip({
      content: {
        text: options.tooltip.column.content,
        title: options.tooltip.column.title
      },
      style: {
        classes: 'qtip-dark',
        width: '275px'
      },
      position: {
        my: 'left center'
      }
    });

    const sdate = $('#sdate');
    const fdate = $('#fdate');
    const startDate = $('#startDate').ejDateTimePicker({
      width: 250,
      locale: ejLocale,
      buttonText: options.buttonText,
      dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
      timeDisplayFormat: 'HH:mm:ss',
      value: sdate.val(),
      change: function (args) {
        sdate.val(args.value);
      }
    }).data('ejDateTimePicker');
    const finishDate = $('#finishDate').ejDateTimePicker({
      width: 250,
      locale: ejLocale,
      buttonText: options.buttonText,
      dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
      timeDisplayFormat: 'HH:mm:ss',
      value: fdate.val(),
      change: function (args) {
        fdate.val(args.value);
      }
    }).data('ejDateTimePicker');

    if(itemID > 0) {
      let dmAds;
      let listGrid;
      const adsDialog = $('#adsDialog').ejDialog({
        width: 830,
        allowDraggable: true,
        enableModal: true,
        showOnInit: false
      }).data('ejDialog');
      const adsSel = new Selectors();

      const dm = ej.DataManager({
        url: `${ajaxurl}?action=load_places_ads_item&pid=${itemID}&sam_pro_nonce=${options.samProNonce}`,
        removeUrl: `${ajaxurl}?action=unlink_ad_item&pid=${itemID}&sam_pro_nonce=${options.samProNonce}`,
        updateUrl: `${ajaxurl}?action=update_place_ad&sam_pro_nonce=${options.samProNonce}`,
        requestType: 'json',
        adaptor: new ej.UrlAdaptor()
      });
      const grid = $('#grid').ejGrid({
        dataSource: dm,
        locale: ejLocale,
        allowSorting: true,
        allowPaging: true,
        pageSettings: {pageSize: options.itemsPerPage},
        allowSelection: true,
        selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
        editSettings: {allowEditing: true, allowDeleting: true, showDeleteConfirmDialog: true},
        toolbarSettings: {
          showToolbar: true,
          toolbarItems: [
            "edit",
            ej.Grid.ToolBarItems.Update,
            ej.Grid.ToolBarItems.Cancel,
            ej.Grid.ToolBarItems.Delete
          ],
          customToolbarItems: ["Link", "Edit_Ad", "Refresh"]
        },
        columns: [
          {field: 'pid', headerText: 'Place ID', visible: false},
          {
            field: 'aid',
            headerText: localeStrings.adId,
            isPrimaryKey: true,
            allowEditing: false,
            textAlign: ej.TextAlign.Right,
            width: 90
          },
          {field: 'title', headerText: localeStrings.name, allowEditing: false, width: 180},
          {field: 'description', headerText: localeStrings.desc, allowEditing: false},
          {
            field: 'weight',
            headerText: localeStrings.weight,
            textAlign: ej.TextAlign.Right,
            allowEditing: true,
            editType: ej.Grid.EditingType.Numeric,
            defaultValue: 10,
            validationRules: {range: [0, 10]},
            width: 100
          },
          {
            field: 'trash',
            headerText: localeStrings.status,
            allowEditing: false,
            textAlign: ej.TextAlign.Center,
            width: 100
          }
        ],
        create: function (args) {
          $('.Link').parent('li').attr('title', localeStrings.linkAds);
          $('#grid_delete').attr('title', localeStrings.unlinkAd);
          $('.Refresh').parent('li').attr('title', localeStrings.refresh);
          $('.Edit_Ad').parent('li').attr('title', localeStrings.editAd);
        },
        toolbarClick: function (args) {
          const tbarObj = $(args.target);
          const rec = this.getSelectedRecords();
          if (tbarObj.hasClass("Refresh")) this.refreshContent();
          else if (tbarObj.hasClass('Link')) getList();
          else if (tbarObj.hasClass('Edit_Ad')) {
            if (rec.length > 0) {
              const item = rec[0].aid;
              document.location = options.adEditorUrl + item;
            }
          }
        },
        actionComplete: function (args) {
          const $tb = $('#grid_toolbarItems');
          let li;
          li = $('#grid_delete');
          $tb.ejToolbar('disableItem', li);
          li = $('#grid_Edit_Ad');
          $tb.ejToolbar('disableItem', li);
        },
        recordClick: function (args) {
          const $tb = $('#grid_toolbarItems');
          let li;
          const recs = this.getSelectedRecords();
          const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
          li = $('#grid_delete');
          $tb.ejToolbar(action, li);
          li = $('#grid_Edit_Ad');
          $tb.ejToolbar(action, li);
        }
      }).data('ejGrid');

      function getList() {
        dmAds = ej.DataManager({
          url: `${ajaxurl}?action=list_ads&pid=${itemID}&sam_pro_nonce=${options.samProNonce}`,
          requestType: 'json',
          adaptor: new ej.UrlAdaptor()
        });
        listGrid = $('#adsGrid').ejGrid({
          dataSource: dmAds,
          locale: ejLocale,
          allowTextWrap: true,
          allowPaging: true,
          pageSettings: {pageSize: options.itemsPerPage},
          allowSorting: true,
          allowSelection: true,
          selectionType: ej.Grid.SelectionType.Multiple,
          selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
          columns: [
            {field: 'aid', headerText: localeStrings.adId, isPrimaryKey: true, textAlign: ej.TextAlign.Right, width: 120},
            {field: 'title', headerText: localeStrings.name, width: 280},
            {field: 'description', headerText: localeStrings.desc, width: 400}
          ],
          rowSelected: function(args) {
            if(!adsSel.service) {
              adsSel.page = args.model.pageSettings.currentPage;
              const d = adsSel.pids[adsSel.page].slice(0);
              const cr = d.indexOf(args.data.aid);
              if(cr > -1) adsSel.removePid(args.data.aid);
              else adsSel.pids = args.data.aid;
            }
          },
          actionComplete: function(args) {
            const d = adsSel.ids.slice(0);
            adsSel.service = true;
            if(d.length !== 0) {
              for(let i = 0; i < this.model.currentViewData.length; i++) {
                for(let j = 0; j < d.length; j++) {
                  if(d[j] === this.model.currentViewData[i].aid) {
                    this.multiSelectCtrlRequest = true;
                    this.selectRows(i);
                    if(args.requestType === 'paging') {
                      adsSel.page = args.currentPage;
                      adsSel.pids = this.model.currentViewData[i].aid;
                    }
                    else if(args.requestType === 'refresh') {
                      adsSel.page = 1;
                      adsSel.pids = this.model.currentViewData[i].aid;
                    }
                  }
                }
              }
            }
            adsSel.service = false;
          }
        }).data('ejGrid');

        adsSel.sid = '';
        adsDialog.open();
      }

      $('#cancel-ads').on('click', () => {
        adsDialog.close();
        listGrid.destroy();
      });

      $('#select-ads').on('click', () => {
        const sid = adsSel.sid;

        if(sid !== '') {
          $.post(ajaxurl + '?action=link_ads', {
            pid: itemID,
            sid: sid,
            sam_pro_nonce: options.samProNonce
          }).done((data) => (grid.refreshContent()));
        }
        adsDialog.close();
        listGrid.destroy();
      });
    }
  });
})(jQuery);
